export const ACCEPTOR_ERROR_CODE = {
    GENERIC: { code: 20000, message: "Generic error" },
    ALREADY_LOGGED_IN: { code: 20001, message: "Customer already logged-in" },
    INVALID_TOKEN: { code: 20002, message: "Invalid token" },
    INVALID_DOMAIN: { code: 20003, message: "Invalid domain" },
    SOURCE_NOT_ALLOWED: { code: 20004, message: "Source not allowed" },
    INVALID_SOURCE: { code: 20005, message: "Source not allowed" },
    STREAMER_UNAVAILABLE: { code: 20006, message: "Streamer service unavailable" },
    WEBAPP_UNAVAILABLE: { code: 20007, message: "Webapp service unavailable" },
    SESSION_EXPIRED: { code: 20008, message: "Session expired" },
    SESSION_NOT_FOUND: { code: 20009, message: "Session not found on this domain" },
    TOKEN_EXPIRED: { code: 20010, message: "Token expired" },
    INVALID_CREDENTIALS: { code: 20011, message: "Invalid credentials" },
    SERVICE_UNAVAILABLE: { code: 20012, message: "Acceptor service unavailable" },
    PREFERENCE_NOT_FOUND: { code: 20013, message: "Preference not found" },
    STREAMER_REQUEST_TIMEOUT: { code: 20014, message: "Streamer request timeout" },
    SERVER_INIT_CREATE_DB: { code: 20015, message: "Fail to create database on server initialization" },
    SERVER_INIT_CREATE_TABLE: { code: 20016, message: "Fail to create table on server initialization" },
    RESOURCE_NOT_FOUND: { code: 20017, message: "Resource not found" },
    NOT_AUTHORIZED: { code: 20018, message: "Not authorized" },
    MAX_SIMULTANEOUS_CONNECTIONS: { code: 20119, message: "Maximum number of simultaneous connections" },
    STREAMER_BUSY: { code: 20120, message: "Streamer server too busy please try again later" },
    DEVICE_ID_ALREADY_USED: { code: 20121, message: "Device ID already in use" },
    DEVICE_ID_DUPLICATED: { code: 20122, message: "Device ID already in use" },
    CORRELATION_ID_IN_USE: { code: 20123, message: "Correlation ID already in use" },
    CORRELATION_ID_NOT_FOUND: { code: 20124, message: "Correlation ID not found" },
};